import { ApiClient } from "@network/client";
import { IApiClient } from "@common/network/interfaces";
import { getConfig } from "@config/index";
import { IUserDetails } from "@common/redux/admin/interface";
import {
  getAdminUsers,
  getCustomizedUserData,
  updateUserWithGroupsRoles,
  getOrganizationUserAttributes,
} from "../apis/urls";

const ENDPOINTS = {
  getOrganizationDetails: () => getOrganizationUserAttributes,
  getCollaborativeShareUserList: () => getAdminUsers,
  getUserDetails: () => getCustomizedUserData,
  updateUserDetails: () => updateUserWithGroupsRoles,
};

export { ENDPOINTS as AdminEndPoints };

class AdminPannelRepository {
  private apiClient: IApiClient;
  constructor(apiClient: IApiClient) {
    this.apiClient = apiClient;
  }

  public getOrganizationDetails = async () => {
    const result = await this.apiClient.get(
      ENDPOINTS.getOrganizationDetails(),
      {},
      {
        baseURL: getConfig().APP_BE_BASE_URL,
      }
    );
    return result?.data;
  };

public getCollaborativeShareUserList = async () => {
  const result = await this.apiClient.get(
    ENDPOINTS.getCollaborativeShareUserList(),
    {},
    {
      baseURL: getConfig().APP_BE_BASE_URL,
    }
  );
  return result?.data;
};

  public getUserDetails = async (userId: string) => {
    if (!userId) return;
    const url: string = `${ENDPOINTS.getUserDetails()}/${userId}`;
    const result = await this.apiClient.get(
      url,
      {},
      {
        baseURL: getConfig().APP_BE_BASE_URL,
      }
    );
    return result?.data;
  };

  public updateUserDetails = async (data: {
    userData: IUserDetails;
    userId: string;
  }) => {
    const url: string = `${ENDPOINTS.updateUserDetails()}/${data.userId}`;
    const payload = data.userData;
    const result = await this.apiClient.put(
      url,
      payload,
      {},
      {
        baseURL: getConfig().APP_BE_BASE_URL,
      }
    );
    return result.data;
  };
}

const adminPannelRepository = new AdminPannelRepository(ApiClient);

export { adminPannelRepository as AdminPennelRepository };
